import React, {useEffect, useState} from "react";
import {Navigation} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "../../../style/common/components/swiper/event_msg_template_swiper.scss";
import {fetchPost} from "../../utils/FetchUtil.ts";
import {isNotEmpty} from "../../utils/CommonUtil.ts";
import {Image} from "react-bootstrap";
import {url} from "../../utils/UrlsUtil.ts";
import {img} from "../../utils/ImageUtil.ts";

interface EventMsgTemplateSwiperProps {
    templateKbn: string;
    showTemplate?: boolean;
    onSelectedMsg?: (msg: string) => void;
    onSelectedCategory?: (code: string) => void;
}
const EventMsgTemplateSwiper:React.FC<EventMsgTemplateSwiperProps> = (
    {
        templateKbn = "20",
        showTemplate = true,
        onSelectedMsg = () => {},
        onSelectedCategory = () => {},
    }
) => {
    const [selectedCategoryCode, setSelectedCategoryCode] = useState<string>("");
    const [eventCategoryList, setEventCategoryList] = useState<EventCategoryDto[]>([]);
    const [templateList, setTemplateList] = useState<SampleMessageDto[]>([]);
    useEffect(() => {
        const initComponent = async () =>{
            try{
                const data = await fetchPost({
                    action: "/api/template/event/categories",
                    data: {},
                });
                if(data != null){
                    //オンラインメッセージサンプルリスト
                    setEventCategoryList(data["event_category_list"]);
                }
            }catch (e) {
                console.log(e);
            }
        }
        initComponent().finally(()=>{});
    }, []);
    useEffect(() => {
        const getCategoryTemplateList = async () =>{
            try{
                const data = await fetchPost({
                    action: "/api/template/event/category/msg_templates",
                    data: {template_kbn: templateKbn, event_category_code: selectedCategoryCode},
                });
                if(data != null){
                    //イベントカテゴリーメッセージテンプレートを取得
                    setTemplateList(data["msg_sample_list"]);
                }
            }catch (e) {
                console.log(e);
            }
        }
        if(showTemplate){
            getCategoryTemplateList().finally(()=>{});
        }
    }, [selectedCategoryCode]);
    const onClickCategory = (code: string) => {
        setSelectedCategoryCode(code);
        onSelectedCategory(code);
    }
    if(eventCategoryList && eventCategoryList.length > 0){
        return (
            <div className="event-msg-template-list">
                <Swiper spaceBetween={20}
                        slidesPerView={4}
                        navigation={{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }}
                        modules={[Navigation]}
                        breakpoints={{
                            768: {slidesPerView: 8}
                        }}
                        className="event-categories-swiper"
                >
                    <SwiperSlide onClick={()=>{onClickCategory("");}}>
                        <dl className={`event-category-item${isNotEmpty(selectedCategoryCode)? '' : ' selected-item'}`}>
                            <dd><Image src={url("/images/common/all.png")} fluid={true}></Image></dd>
                            <dt>すべて</dt>
                        </dl>
                    </SwiperSlide>
                    {eventCategoryList.map( ((eventCategory, idx) => (<SwiperSlide key={`event_category_item_${idx}`} onClick={()=>{onClickCategory(eventCategory.code);}}>
                        <dl className={`event-category-item${eventCategory.code === selectedCategoryCode ? ' selected-item' : ''}`}>
                            <dd><Image src={img(eventCategory.icon_path)} fluid={true}></Image></dd>
                            <dt>{eventCategory.name}</dt>
                        </dl>
                    </SwiperSlide>)))}
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                </Swiper>
                {showTemplate && <Swiper spaceBetween={20}
                                         slidesPerView={3}
                                         centeredSlides={false}
                                         navigation={{
                                             nextEl: '.swiper-button-next',
                                             prevEl: '.swiper-button-prev',
                                         }}
                                         modules={[Navigation]}
                                         className="event-msg-template-swiper"
                >
                    {templateList.map( ((msg: SampleMessageDto, idx: number) => (
                        <SwiperSlide key={`msg_template_item_${idx}`} onClick={()=>{onSelectedMsg(msg.sample_message);}}>
                            <dl className={`msg-template-item`}>
                                <dt>{msg.title}</dt>
                                <dd dangerouslySetInnerHTML={{ __html: msg.sample_message.replace(/<br\s*\/?>/g, '\n').replace(/\n/g, '<br />')}}></dd>
                            </dl>
                        </SwiperSlide>
                    )))}
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                </Swiper>}
            </div>
        );
    }else {
        return <></>;
    }
}
export default EventMsgTemplateSwiper;

